import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import home from '@/views/home'
import login from '@/views/login'
import mobilePartnerLogin from '@/views/mobilePartner/login'
import mobilePartnerWithdrawal from '@/views/mobilePartner/withdrawal'
import mobilePartnerWithdrawalAmount from '@/views/mobilePartner/withdrawalAmount'

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            component: home,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/home/:option',
            name: 'home',
            component: home,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        }, {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                keepAlive: true,
                requiresAuth: false
            }
        }, {
            path: '/partnerLogin',
            name: 'mobilePartnerLogin',
            component: mobilePartnerLogin,
            meta: {
                keepAlive: false,
            }
        }, {
            path: '/partnerWithdrawal',
            name: 'mobilePartnerWithdrawal',
            component: mobilePartnerWithdrawal,
            meta: {
                keepAlive: true,
            }
        }, {
            path: '/partnerWithdrawalAmount',
            name: 'mobilePartnerWithdrawalAmount',
            component: mobilePartnerWithdrawalAmount,
            meta: {
                keepAlive: true,
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    let loginStatus = store.getters['user/login'];
    if (!loginStatus && to.meta.requiresAuth) {
        let isMobile =  navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        isMobile ? next({path: '/partnerLogin'}) : next({path: '/login'});
    } else {
        next();
    }
});

export default router;
